import React from 'react';
import { cx } from '@emotion/css';
import { Trans } from 'react-i18next';
import { Typography } from '@mui/material';
import * as classes from './paragraph.styles';

interface Props {
  label: string;
  componentInterpolation?: React.ReactNode[];
  className?: string;
}

export const ParagraphComponent: React.FunctionComponent<Props> = props => {
  const { label, componentInterpolation, className } = props;

  return (
    <>
      {Boolean(label) && (
        <Trans
          components={
            Boolean(componentInterpolation) && [
              <Typography key={0} className={cx(classes.root, className)} component="span" variant="subtitle2">
                {componentInterpolation}
              </Typography>,
            ]
          }
        >
          <Typography className={cx(classes.root, className)} component="span" variant="subtitle2">
            {label}
          </Typography>
        </Trans>
      )}
    </>
  );
};
